export const TOKENOMICS_SEGMENTS = [
  { label: "Pre-sale", pct: 28, tokens: "280M", color: "#c4b5fd" },
  { label: "Pre-seed", pct: 4, tokens: "40M", color: "#e879a8" },
  { label: "Team", pct: 5, tokens: "50M", color: "#93c5fd" },
  { label: "Advisors", pct: 2, tokens: "20M", color: "#f87171" },
  { label: "Liquidity", pct: 16, tokens: "160M", color: "#fdba74" },
  { label: "Ecosystem", pct: 25, tokens: "250M", color: "#86efac" },
  { label: "Community Rewards", pct: 15, tokens: "150M", color: "#d9d97a" },
  { label: "Marketing", pct: 5, tokens: "50M", color: "#fb923c" },
];
